import Backbone from 'backbone';
import Config from '../config';

import View from './view';

import { promisify } from '../utils/promisify'

export default View.extend( {
    
    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        this.listenTo( this, 'reply:begin', replyTo => {
            this.file_ = null;
            this.replyTo_ = replyTo;
            this.render()
                .then( view => view.$( 'textarea' ).focus() );
        } );
    },
    
    events: {

        'keydown textarea': function(e) {
            if (e.keyCode !== 13) return;

            return send( this ), e.preventDefault(), false;
        },

        'keyup textarea': function() {
            this.text_ = this.$( 'textarea' ).val();
        },

        'click .comment-form--attached-file-remove': function() {
            this.removeAttachment();
        },

        'click .comment-form--attached-file-send': function() {
            return send( this ), false;
        },

        'click .comment-form--reply-remove': function() {
            this.removeReply();
        },

    },

    serialize() {
        let { allowAttachPhotoVideo } = this.options;
        if (allowAttachPhotoVideo === undefined)
            allowAttachPhotoVideo = true;

        const ctx = {
            commentText: this.text_ || '',
            allowAttachPhotoVideo,
        };

        if (this.file_)
            ctx.file = Object.create( this.file_ );

        if (this.replyTo_)
            ctx.replyTo = this.replyTo_.toJSON();

        return ctx;
    },

    onBind(model) {
        this.file_ = null;
        this.text_ = null;
        this.replyTo_ = null;
    },

    removeAttachment() {
        this.file_ = null;
        this.render();
    },

    removeReply() {
        this.replyTo_ = null;
        this.render()
            .then( view => view.$( 'textarea' ).focus() );
    },

    attach_(originalName, type, uploading) {
        this.replyTo_ = null;
        this.file_ = {
            originalName,
            type,
            uploading,
        };

        this.render()
            .then( view => view.$( 'textarea' ).focus() );
    },

    [View.event( 'AttachControls:file:upload-done' )](originalName, type, uploading) {
        this.attach_( originalName, type, uploading );
    },

} );

function send(view) {
    let attachment;
    if (view.file_) {
        const { type, originalName } = view.file_;
        attachment = view.file_.uploading.then( name => 
            ({ name, type, originalName }) );
    }

    view.trigger( 'send', view.$( 'textarea' ).val(), view.replyTo_, attachment );

    view.file_ = null;
    view.text_ = null;
    view.replyTo_ = null;

    view.render()
        .then( view => view.$( 'textarea' ).focus() );
}


// WEBPACK FOOTER //
// ./src/js/view/comment.form.js